// extracted by mini-css-extract-plugin
module.exports = {"root":"Card-module__root___2jZbL","axis":"Card-module__axis___2Ivt_","rate":"Card-module__rate___xzTyH","grid":"Card-module__grid___BCdCi"};